import React, { useState } from "react";
import WappIcono from "../../../components/wappIcono";
import "./seleccion.css";

/** Copia al portapapeles; con el permiso negado (o sin https) usa el truco del cuadro escondido. */
export const copiarTexto = async (t: string): Promise<boolean> => {
	try {
		await navigator.clipboard.writeText(t);
		return true;
	} catch {
		try {
			const a = document.createElement("textarea");
			a.value = t;
			a.style.position = "fixed";
			a.style.opacity = "0";
			document.body.appendChild(a);
			a.select();
			const ok = document.execCommand("copy");
			document.body.removeChild(a);
			return ok;
		} catch {
			return false;
		}
	}
};

/** La palomita redonda de cada mensaje en modo selección (como WhatsApp). */
export const MarcaSeleccion: React.FC<{ on: boolean }> = ({ on }) => (
	<span className={"selm" + (on ? " on" : "")} aria-hidden="true">{on ? <WappIcono n="check" /> : null}</span>
);

/**
 * Barra de selección múltiple (Esteban, 2026-10-12): "N seleccionados", Copiar (el texto de todos, en orden) y Reenviar
 * (salen como mensajes nuevos, sin "Reenviado"). Reemplaza al cuadro de escribir mientras se elige.
 */
export const BarraSeleccion: React.FC<{ n: number; texto: () => string; onReenviar?: (() => void) | null; onCancelar: () => void; compacta?: boolean }> = ({ n, texto, onReenviar, onCancelar, compacta }) => {
	const [copiado, setCopiado] = useState<boolean>(false);
	const copiar = async () => {
		const t = texto();
		if (!t) return;
		if (await copiarTexto(t)) { setCopiado(true); setTimeout(() => setCopiado(false), 1600); }
	};
	return (
		<div className={"selb" + (compacta ? " compacta" : "")} role="toolbar" aria-label="Mensajes seleccionados">
			<button type="button" className="selb-x" onClick={onCancelar} aria-label="Cancelar selección" title="Cancelar"><WappIcono n="x" /></button>
			<span className="selb-n">{n ? n + (n === 1 ? " seleccionado" : " seleccionados") : "Toca los mensajes"}</span>
			<button type="button" className="selb-b" disabled={!n} onClick={copiar} title="Copiar el texto"><WappIcono n="copy" /><span>{copiado ? "Copiado" : "Copiar"}</span></button>
			{onReenviar ? <button type="button" className="selb-b fuerte" disabled={!n} onClick={onReenviar} title="Reenviar como mensajes nuevos"><WappIcono n="forward" /><span>Reenviar</span></button> : null}
		</div>
	);
};
